import React from "react";

const Icon = ({ src, alt, ...props }) => (
  <div className="icon-container">
    <img src={src} alt={alt} {...props} />
  </div>
);

export default Icon;